import { VertexDeclaration } from "../../RenderEngine/VertexDeclaration";
import { VertexElement } from "../../renders/VertexElement";
import { VertexElementFormat } from "../../renders/VertexElementFormat";
import { Sprite2DGeometry } from "./Sprite2DGeometry";
export class MeshVG extends Sprite2DGeometry {
    static __init__() {
        MeshVG.vertexDeclaration = new VertexDeclaration(24, [
            new VertexElement(0, VertexElementFormat.Vector2, 0),
            new VertexElement(8, VertexElementFormat.Vector4, 1),
        ]);
    }
    constructor() {
        super(MeshVG.const_stride, 4, 4);
        this._vbFloat32Array = null;
    }
    onVBRealloc(buff) {
        this._vbFloat32Array = new Float32Array(buff);
    }
    onIBRealloc(buff) {
    }
    addVertAndIBToMesh(points, rgba, ib) {
        var startpos = this._vertNum * MeshVG.const_stride;
        this.expVBSize(points.length / 2 * MeshVG.const_stride);
        var f32pos = startpos >> 2;
        var vbdata = this._vbFloat32Array;
        var ci = 0;
        let r = ((rgba >>> 16) & 0xff) / 255.0;
        let g = ((rgba >>> 8) & 0xff) / 255.0;
        let b = (rgba & 0xff) / 255.0;
        let a = (rgba >>> 24) / 255.0;
        var sz = points.length / 2;
        for (var i = 0; i < sz; i++) {
            vbdata[f32pos++] = points[ci];
            vbdata[f32pos++] = points[ci + 1];
            ci += 2;
            vbdata[f32pos++] = b;
            vbdata[f32pos++] = g;
            vbdata[f32pos++] = r;
            vbdata[f32pos++] = a;
        }
        this.expIBSize(ib.length * 2);
        (new Uint16Array(this._IBBuff, this._indexNum * 2, ib.length)).set(new Uint16Array(ib));
        this._vertNum += sz;
        this._indexNum += ib.length;
    }
    get vertexDeclarition() {
        return MeshVG.vertexDeclaration;
    }
}
MeshVG.const_stride = 24;
MeshVG.vertexDeclaration = null;
